import './SportSliderItem.less';

import clsx from 'clsx';
import React, { FC, memo, ReactNode } from 'react';

import { fireGAEvent } from '@/analytics';
import { CURRENT_PAGE } from 'nike-ui/src/common/routing';
import { navigate } from '@/routing';

interface SportSliderItemProps {
    active: boolean;
    label: string;
    icon: ReactNode;
    route: string;
    params: object;
    trackData: object;
}

const SportSliderItem: FC<SportSliderItemProps> = ({
    active,
    label,
    icon: Icon,
    route = CURRENT_PAGE,
    params,
    trackData
}) => {
    function changeSlug() {
        if (trackData) {
            fireGAEvent(
                // @ts-ignore
                trackData.category ? trackData.category : CURRENT_PAGE,
                // @ts-ignore
                trackData.action ? trackData.action : label,
                // @ts-ignore
                trackData.label
            );
        }
        navigate(route, params);
    }

    return (
        <>
            <button
                className={clsx('sport-slider-item flex flex-col items-center pt-15 c-default bg-white', { active })}
                onClick={changeSlug}
            >
                {typeof Icon === 'object' ? (
                    Icon
                ) : typeof Icon === 'function' ? (
                    <Icon />
                ) : (
                    <div className={`sport-icon-small p-rel icon-${Icon}`} />
                )}
                <div className="ellipsis fs-10 pt-5 pb-3">{label}</div>
            </button>
            <div className="sport-slider-item-vertical-border" />
        </>
    );
};

export default memo(SportSliderItem, (props, nextProps) => props.active === nextProps.active);
